import styled from 'styled-components';

// Base button styles that all buttons will inherit
const BaseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
  will-change: transform, background-color;
  border: none;
  outline: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

//   svg {
//     width: 16px;
//     height: 16px;
//   }
`;

// Primary button (green)
export const PrimaryButton = styled(BaseButton)`
  background-color: var(--primary-green);
  color: white;

  &:hover:not(:disabled) {
    background-color: var(--primary-green-dark);
  }
`;

export const LargePrimaryButton = styled(PrimaryButton)`
  padding: 0.75rem 1.5rem;
  font-size: 1.2rem;
`;


// Secondary button (outlined)
export const SecondaryButton = styled(BaseButton)`
  background-color: white;
  color: var(--primary-green);
  border: 1px solid var(--primary-green);

  &:hover:not(:disabled) {
    background-color: #eafbe7;
  }
`;

// Danger button (red)
export const DangerButton = styled(BaseButton)`
  background-color: #dc3545;
  color: white;

  &:hover:not(:disabled) {
    background-color: #c82333;
  }
`;

export const LargeDangerButton = styled(DangerButton)`
  padding: 0.75rem 1.5rem;
  font-size: 1.2rem;
`;

// Text button (no background)
export const TextButton = styled(BaseButton)`
  background-color: transparent;
  color: var(--primary-green);
  padding: 0.25rem 0.5rem;

  &:hover:not(:disabled) {
    background-color: #eafbe7;
  }
`;

// Small button variant
export const SmallButton = styled(BaseButton)`
  padding: 0.25rem 0.75rem;
  font-size: 0.8rem;
`;

// Large button variant
export const LargeButton = styled(BaseButton)`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
`;

// Icon button (circular)
export const IconButton = styled(BaseButton)`
  padding: 0.5rem;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background-color: #eafbe7;
  }
`;

//Gray button
export const GrayButton = styled(BaseButton)`
  background-color: #f0f0f0;
  color: var(--primary-green);
`;

export const DefaultButton = styled(BaseButton)`
  background-color: #f0f0f0;
  color: #333;
    
  &:hover:not(:disabled) {
    background-color: #e0e0e0;
  }
`;

export const EditIconButton = styled.button`
background: none;
border: none;
color: #666;
cursor: pointer;
padding: 0.25rem;
display: inline-flex;
align-items: center;
margin-left: 0.25rem;

&:hover {
  color: var(--primary-green);
}
`;

// Close button for modals/sheets
export const CloseButton = styled(BaseButton)`
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 0.45rem 0.75rem;
  font-weight: 700;
  color: #111827;
  font-size: 0.875rem;

  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #d1d5db;
    color: var(--primary-green, #2D882D);
  }

  &:active {
    transform: translateY(1px);
  }
`;